export default __webpack_public_path__ + "static/media/mm.c7e5ee84.png";